import { Component, OnChanges, EventEmitter } from '@angular/core';
import { filter } from 'rxjs/operators';
import { BaseComponent } from '../../shared/base-components/base.component';
import { PhoneNumberUSAPipe } from '../../shared/pipes/phone-number-usa.pipe';
import { ModalSize } from '../../shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerContact } from '../models/customer-contact.model';
import { ContactMethodType } from '../models/enums/contact-method-type.enum';
import { CustomerManageService } from '../shared/customer-manage.service';
import { ContactContext, CustomerContactModalComponent } from './customer-contact-modal.component';
import { HistoricalContactContext, HistoricalCustomerContactModalComponent } from './historical-customer-contact-modal.component';

@Component({
    selector: 'customer-contact',
    templateUrl: './customer-contact.html',
    inputs: ['customerNumber', 'contacts', 'contactId', 'canEdit', 'isFullRedactionNecessary', 'isShowSelect', 'isShowHistory', 'isShowTitle', 'isAutoPopulateContacts'],
    outputs: ['onContactChange', 'onSelectChange']
})

export class CustomerContactComponent extends BaseComponent implements OnChanges {
    public contacts: CustomerContact[];
    public contactId: number;
    public customerNumber: number;
    public canEdit: boolean;
    public isShowSelect = false;
    public isShowHistory = true;
    public isShowTitle = true;
    public isFullRedactionNecessary = true;
    public isAutoPopulateContacts = true;
    public onContactChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    public onSelectChange: EventEmitter<CustomerContact> = new EventEmitter<CustomerContact>();
    public selectedContact: number;

    private contactTypes = new ContactMethodType();
    private phoneNumberPipe = new PhoneNumberUSAPipe();

    constructor(
        public modalService: MvdModalService,
        private customerService: CustomerManageService
    ) {
        super();
    }

    ngOnInit() {
        if (this.contacts !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumber != null) {
            this.populateContacts(this.customerNumber);
        }
    }

    ngOnChanges() {
        if (this.contacts !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumber != null) {
            this.populateContacts(this.customerNumber);
        }

        if (this.contactId) {
            this.selectedContact = this.contactId;
        }
    }

    populateContacts(customerNumberId: number) {
        if (this.isAutoPopulateContacts) {
            this.customerService.getCustomerContacts(customerNumberId)
                .subscribe(result => {
                    this.contacts = result;
                },
                e => this.handleValidationResult(e),
                () => {
                    this.denormalizeData();
                });
        }
    }

    denormalizeData() {
        for (const contact of this.contacts) {
            contact.contactType = this.getValues(contact.contactMethodTypeId, this.contactTypes);
            if (contact.contactMethodTypeId == this.contactTypes.BusinessCell.id || contact.contactMethodTypeId == this.contactTypes.BusinessFax.id
                || contact.contactMethodTypeId == this.contactTypes.BusinessLandline.id || contact.contactMethodTypeId == this.contactTypes.HomeLandline.id
                || contact.contactMethodTypeId == this.contactTypes.PersonalCell.id || contact.contactMethodTypeId == this.contactTypes.PersonalFax.id) {
                contact.customerContactValue = this.phoneNumberPipe.transform(contact.customerContactValue);
            }
        }
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }

    correspondenceEnabled(item) {
        console.log(item);
    }

    addContact() {
        const data = new ContactContext(0, this.customerNumber);
        this.modalService.open(CustomerContactModalComponent, data, ModalSize.Medium).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(() => {
                this.onContactChange.emit(true);
                this.populateContacts(this.customerNumber);
            });
    }

    editContact(id) {
        const data = new ContactContext(id, this.customerNumber);
        this.modalService.open(CustomerContactModalComponent, data, ModalSize.Medium).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(() => {
                this.onContactChange.emit(true);
                this.populateContacts(this.customerNumber);
            });
    }

    showHistory(id) {
        const data = new HistoricalContactContext(this.customerNumber);
        this.modalService.open(HistoricalCustomerContactModalComponent, data);
    }

    onSelectChanged(customerContact: CustomerContact): void {
        this.onSelectChange.emit(customerContact);
    }
}
